import { BASE_ASSETS } from "@assets/templates/constants";
import type { TemplateDefinition } from "@assets/templates/types";
import { DocumentInputContentV1 } from "@demo/types/documentContent";

export const licensePlateExample: TemplateDefinition = {
  mode: "compose",
  slug: "license-plate-example",
  version: 1,
  title: "License plate",
  description: "OCR + localization",
  thumbnailUuid: BASE_ASSETS.licensePlateExample.uuid,
  assets: [BASE_ASSETS.licensePlateExample],
  request: {
    model: "perceptron-mk1.5",
    system: [],
    user: [
      {
        type: "media",
        value: [
          {
            type: "image",
            value: {
              uuid: BASE_ASSETS.licensePlateExample.uuid,
              extension: BASE_ASSETS.licensePlateExample.extension,
              annotations: { points: [], boundingBoxes: [] },
            },
          },
        ],
      },
      {
        type: "paragraph",
        value: { type: "text", value: "Give me the license plate number." },
      },
    ],
    outputAnnotations: true,
    variables: {},
    temperature: 0,
    annotationFormat: "box",
    enableThinking: false,
  } satisfies DocumentInputContentV1,
};
